import { Avatar, Box, Grid2 as Grid, Typography } from '@mui/material';

import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import crown1 from '../../assets/crown1.json';
import crown2 from '../../assets/crown2.json';
import crown3 from '../../assets/crown3.json';
import { useNavigate } from 'react-router-dom';

// Define the types for a single champion
interface Champion {
  file_name: string;
  isDefault: boolean;
  name: string;
  score: string;
  uid: string;
  handle: string;
}

// Define the props type for the component
interface TopChampsProps {
  topChamps: Champion[];
  isMobile: boolean;
  type: string;
}

const transparentStyle = {
  color: 'white',
  fontWeight: 700,
  letterSpacing: 1,
  fontFamily: 'Baloo2'
};

const renderChampion = (
  champ: Champion,
  index: number,
  isMobile: boolean,
  isFirst: boolean,
  crown: any,
  borderColor: string,
  boxShadow: string,
  type: string
) => {
  const navigate = useNavigate();
  return (
    <Grid key={champ.uid + index} size={{ xs: 4, sm: 4 }} sx={{ textAlign: 'center' }} mt={!isFirst ? 5 : 0}>
      <Box
        sx={{ padding: 2, position: 'relative', cursor: 'pointer' }}
        onClick={() => navigate(`/user/${champ.handle}`)}>
        <div
          style={{
            position: 'absolute',
            top: isMobile ? '-3%' : '-15%',
            left: isMobile ? '55%' : '50%',
            transform: 'translateX(-50%)',
            zIndex: 1
          }}>
          <Player loop src={crown} style={isMobile ? { width: 80, height: 80 } : { width: 150, height: 150 }} />
        </div>
        <Avatar
          src={
            type === 'clans'
              ? `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/ClanAvatars/medium/${champ?.file_name}`
              : champ.isDefault
                ? `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/UserAvatars/${champ?.file_name}`
                : `${process.env.REACT_APP_DEFAULT_AVATAR}/${champ?.uid}/PROFILE/IMAGES/medium/${champ?.file_name}`
          }
          alt={champ.name}
          sx={{
            width: isMobile ? 90 : 193,
            height: isMobile ? 90 : 193,
            filter: type === 'clans' || champ.isDefault ? 'none' : 'blur(4px)',
            margin: 'auto',
            mt: 3,
            border: {
              xs: `4px solid ${borderColor}`,
              md: `10px solid ${borderColor}`
            },
            boxShadow
          }}
        />
        <Box
          sx={{
            position: 'relative',
            display: 'inline-block',
            width: isMobile ? 33 : 62,
            height: isMobile ? 33 : 62
          }}>
          {/* Outer Circular Border */}
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              background:
                'linear-gradient(89.92deg, #E02780 0.07%, #FF5D83 0.08%, #B465FF 38.02%, #FF9D32 62.98%, #FF7A52 83.45%, #FF4FF1 99.93%)',
              padding: '2px'
            }}>
            {/* Inner Avatar */}
            <Avatar
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#FFFFFF',
                backdropFilter: 'blur(3.23px)',
                background: 'rgba(31, 29, 58, 0.5)',
                borderRadius: '50%'
              }}>
              <Typography
                variant={isMobile ? 'body1' : 'h6'}
                fontSize={isMobile ? 14 : 46}
                fontFamily="Baloo2"
                fontWeight={800}>
                {index + 1}
              </Typography>
            </Avatar>
          </Box>
        </Box>
      </Box>
      <Typography sx={transparentStyle} mt={isMobile ? '-15px' : 0} fontSize={isMobile ? 14 : 34}>
        {champ.name || 'Anonymous'}
      </Typography>
      <Typography sx={{ color: 'white' }} fontSize={isMobile ? 10 : 21} fontFamily="Baloo2" fontWeight={500}>
        {Number(champ.score).toFixed(2)} Points
      </Typography>
    </Grid>
  );
};

const TopChamps: React.FC<TopChampsProps> = ({ topChamps, isMobile, type }) => (
  <Grid
    container
    justifyContent="center"
    spacing={isMobile ? 1 : 2}
    sx={{ mb: isMobile ? 1 : 4, mt: isMobile ? 1 : 5 }}>
    {topChamps[2] &&
      renderChampion(
        topChamps[2],
        2,
        isMobile,
        false,
        crown3,
        'rgba(137, 75, 9, 1)',
        '0px 0px 3.62px 0px rgba(137, 75, 9, 1)',
        type
      )}
    {topChamps[0] &&
      renderChampion(
        topChamps[0],
        0,
        isMobile,
        true,
        crown2,
        'rgba(225, 179, 82, 1)',
        '0px 0px 3.45px 0px rgba(225, 179, 82, 1)',
        type
      )}
    {topChamps[1] &&
      renderChampion(
        topChamps[1],
        1,
        isMobile,
        false,
        crown1,
        'rgba(115, 115, 115, 1)',
        '0px 0px 3.45px 0px rgba(115, 115, 115, 1)',
        type
      )}
  </Grid>
);

export default TopChamps;
